import { useEffect, useState } from "react";
import { Video, MessageCircle } from "lucide-react";
import { fmtFecha } from "../../lib/format";
import { BigButton, StepTitle, acento } from "./KycShell";

export const StepEnviar = ({ brand, mode, operador, onSubmit, busy }) => {
  const [ok, setOk] = useState(false);
  const presencial = mode === "presencial";
  return (
    <div className="space-y-5" data-testid="kyc-step-enviar">
      <StepTitle paso="Último paso" title="Todo listo para enviar">Revisa que tus fotos se vean bien. Cuando toques Enviar, ya no podrás cambiarlas.</StepTitle>
      {presencial && (
        <label className="flex gap-4 items-start p-4 rounded-xl border-2 border-slate-300 bg-white cursor-pointer">
          <input type="checkbox" checked={ok} onChange={(e) => setOk(e.target.checked)} className="mt-1 h-6 w-6 accent-slate-900" data-testid="presencial-confirm-checkbox" />
          <span className="text-base">
            Verifiqué presencialmente que la persona coincide con el documento.
            <span className="block text-sm text-slate-500 mt-1" data-testid="presencial-operator-info">{operador} · {fmtFecha(new Date().toISOString())}</span>
          </span>
        </label>
      )}
      <BigButton color={brand.color} disabled={busy || (presencial && !ok)} onClick={() => onSubmit(ok)} data-testid="kyc-submit-button">
        {busy ? "Enviando…" : "Enviar"}
      </BigButton>
    </div>
  );
};

const CheckAnimado = ({ color }) => (
  <svg viewBox="0 0 56 56" className="kyc-check mx-auto h-20 w-20" fill="none" stroke={color} strokeWidth="3.5" strokeLinecap="round" strokeLinejoin="round" data-testid="kyc-fin-check">
    <circle cx="28" cy="28" r="25" />
    <path d="M17 29l7 7 15-16" />
  </svg>
);

const Volver = ({ brand, url }) => {
  const [s, setS] = useState(5);
  useEffect(() => {
    if (!url) return undefined;
    const t = setInterval(() => setS((x) => x - 1), 1000);
    const r = setTimeout(() => window.location.assign(url), 5000);
    return () => { clearInterval(t); clearTimeout(r); };
  }, [url]);
  if (!url) return <p className="text-sm text-slate-500">Ya puedes cerrar esta página.</p>;
  return (
    <div className="space-y-2">
      <a href={url} className="block" data-testid="kyc-fin-volver"><BigButton tabIndex={-1}>Volver a {brand.nombre}</BigButton></a>
      <p className="text-xs text-slate-400" data-testid="kyc-fin-redirect">Te llevaremos automáticamente en {Math.max(s, 0)} s</p>
    </div>
  );
};

export const StepFin = ({ brand, videollamada, returnUrl }) => (
  <div className="text-center space-y-6 py-6" data-testid="kyc-step-fin">
    <CheckAnimado color={brand.color || acento(brand)} />
    <div className="space-y-2">
      <h1 className="font-heading text-2xl font-semibold tracking-tight" data-testid="kyc-fin-message">Recibimos tus datos</h1>
      <p className="flex items-center justify-center gap-2 text-[15px] text-slate-600" data-testid="kyc-fin-next"><MessageCircle size={16} /> Te avisaremos cuando esté lista.</p>
    </div>
    {videollamada && (
      <div className="flex gap-3 items-start text-sm text-slate-700 bg-slate-50 rounded-2xl p-4 text-left" data-testid="kyc-fin-videollamada">
        <Video className="shrink-0" />
        <span>
          Para terminar tu verificación, agenda una videollamada con {brand.nombre}.
          {brand.whatsapp ? (
            <a className="block font-semibold underline mt-1" href={`https://wa.me/${brand.whatsapp.replace(/\D/g, "")}`} target="_blank" rel="noreferrer" data-testid="kyc-fin-whatsapp">Escribir por WhatsApp al {brand.whatsapp}</a>
          ) : <span className="block mt-1">{brand.nombre} te contactará para agendarla.</span>}
          <span className="block text-sm text-slate-500 mt-1">La videollamada no se graba.</span>
        </span>
      </div>
    )}
    <Volver brand={brand} url={returnUrl || brand.app_url} />
  </div>
);
